import React from "react";
import { Helmet } from "react-helmet";
import Contact from "../components/contact/index";
import Footer from "../components/home/footer";
import Home from "../components/home/index";
import Tech from "../components/technologies";
import Works from "../components/works/index";

if (typeof window !== "undefined") {
  require("smooth-scroll")('a[href*="#"]');
}
const MainPage: React.FC = () => {
  return (
    <div className=" w-full min-h-full font-body">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Anand Ammathil | Portfolio</title>
        <meta
          name="description"
          content="Hi am Anand, this is my portfolio please check-it out "
        />
        <meta
          name="google-site-verification"
          content="I_dRLy-vAA7j00c0lcYn0FJkP4gcrwSNwgZR7rgs7GM"
        />
      </Helmet>
      <Home />
      <Works />
      <Tech />
      <Contact />
      <Footer />
    </div>
  );
};

export default MainPage;
